import InstantQuoteLayout, { InstantQuoteLayoutProps } from './InstantQuoteLayout';

export type { InstantQuoteLayoutProps };
export default InstantQuoteLayout;
